"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Model/Messaging
 */
var MessagingOperationName;
(function (MessagingOperationName) {
    MessagingOperationName["getMessageObjects"] = "get_message_objects";
})(MessagingOperationName = exports.MessagingOperationName || (exports.MessagingOperationName = {}));
var MessagingError;
(function (MessagingError) {
    MessagingError["query_execution_failed"] = "query_execution_failed";
    MessagingError["api_connection_failed"] = "api_connection_failed";
    MessagingError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
})(MessagingError = exports.MessagingError || (exports.MessagingError = {}));
var MessagingOperation = /** @class */ (function () {
    function MessagingOperation(name) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        this._name = name;
        this._parameters = params;
    }
    Object.defineProperty(MessagingOperation.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessagingOperation.prototype, "parameters", {
        get: function () {
            return this._parameters;
        },
        enumerable: true,
        configurable: true
    });
    return MessagingOperation;
}());
exports.MessagingOperation = MessagingOperation;
var MessagingOperations;
(function (MessagingOperations) {
    var GetMessageObjects = /** @class */ (function (_super) {
        __extends(GetMessageObjects, _super);
        function GetMessageObjects(sender, receiver, count) {
            return _super.call(this, MessagingOperationName.getMessageObjects, sender, receiver, count) || this;
        }
        return GetMessageObjects;
    }(MessagingOperation));
    MessagingOperations.GetMessageObjects = GetMessageObjects;
})(MessagingOperations = exports.MessagingOperations || (exports.MessagingOperations = {}));
var ConnectionStatus = /** @class */ (function () {
    function ConnectionStatus() {
    }
    ConnectionStatus.open = 'open';
    return ConnectionStatus;
}());
exports.ConnectionStatus = ConnectionStatus;
//# sourceMappingURL=messaging.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/model/messaging.js
// module id = 232
// module chunks = 0